import {createAsyncThunk} from '@reduxjs/toolkit';
import {hideSpinner, showSpinner} from '../../slices/screenSlice';
import {AppDispatch} from '../../store';
import PlatformApi from 'src/api/PlatformApi';
import SnackActions from 'src/constants/sendSnack/SnackActions';
import {acceptSnack} from './acceptSnack';
import {SnackStatus} from '../../slices/snackSlice';
import {blockUser} from './blockUser';
import Events from 'src/logging/Events';
import ScreenContext from 'src/components/ScreenContext';
import Logger from 'src/logging/Logger';
import CrashlyticsEvents from 'src/logging/Crashlytics';
import {Snack} from 'src/types/snack/Snack';
import AccountStore from 'src/stores/AccountStore';

export type LoadSnackDetailParams = {
  locationId: string;
  externalMsgId: string;
  messageAction?: string;
  context?: React.ContextType<typeof ScreenContext>;
};
export const loadSnackDetail = createAsyncThunk<
  Snack,
  LoadSnackDetailParams,
  {dispatch: AppDispatch}
>(
  'snack/loadSnackDetail',
  async (
    {locationId, externalMsgId: snackId, messageAction: snackAction, context},
    {dispatch},
  ) => {
    dispatch(showSpinner({}));
    let snack: Snack;
    try {
      snack = await PlatformApi.loadSnackDetails(locationId, snackId);
      Logger.Log.LogAPIEvent(
        'PlatformAPI',
        'LoadSnackDetails',
        JSON.stringify({locationId, snackId}),
        JSON.stringify(snack),
      );
      const accountId = AccountStore.getAccountId();
      if (
        snackAction === SnackActions.AcceptSnack &&
        snack.status === SnackStatus.Sent &&
        snack.receiverAccountId === accountId
      ) {
        dispatch(acceptSnack({snackDetails: snack, context}));
      } else if (snackAction === SnackActions.BlockSnack) {
        dispatch(blockUser({snackDetails: snack}));
      } else if (
        snackAction === SnackActions.AcceptSnack &&
        snack.status === SnackStatus.Cancelled
      ) {
        dispatch(hideSpinner());
        return {...snack, isErrormessage: 'true'};
      } else {
        dispatch(hideSpinner());
        return snack;
      }
    } catch (e) {
      CrashlyticsEvents.log(
        'Exception',
        'snack/loadSnackDetail',
        JSON.stringify(e),
        JSON.stringify(snack),
      );
      Events.Error.trackEvent(
        'Exception',
        'snack/loadSnackDetail',
        JSON.stringify(e),
      );
    }
  },
);
